import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class PolicyFormatService {

    private autoAddDash(policyNumber: string) {
        let _returnPolicyNumber = '';
        if (policyNumber.startsWith('15914024') && !policyNumber.startsWith('15914024-')) {
            _returnPolicyNumber = policyNumber.replace('15914024', '15914024-');
        } else {
            _returnPolicyNumber = policyNumber;
        }
        return _returnPolicyNumber;
    }

    formatPolicy(policyNumber: string) {
        let _returnPolicyNumber = '';
        let policy = this.autoAddDash(policyNumber);
        var n = (policy.match(/-/g) || []).length;
        if (n > 1 && !policy.endsWith('-HK')) { //exclude HongKong policies which end with '-HK'
            var f = policy.indexOf('-', 1);
            var l = policy.indexOf('-', f + 1);
            var substr = policy.substring(0, l);
            _returnPolicyNumber = substr;
        } else {
            _returnPolicyNumber = policyNumber;
        }
        return _returnPolicyNumber;
    }

}